export default async (editor, opts = {}) => {
    const panelManager = editor.Panels;
};
